import {
  getRequestWithToken,
  postRequest,
} from '../helpers/request';

export const verifyPersonEmail = (email) => {
  const apiUrl = `persons/check/?email=${email}`;
  return getRequestWithToken(apiUrl);
};

export const getProfile = (filter) => {
  const apiUrl = `persons/profile`;
  return getRequestWithToken(apiUrl);
};

export const getCustomerProfile = () => {
  const apiUrl = `customers`;
  return getRequestWithToken(apiUrl);
};

export const resetPersonPassword = (params) => {
  const apiUrl = `persons/reset-password-email`;
  return postRequest(apiUrl, params);
};